import { Reveal } from "./Reveal";
import { Button } from "./Button";

/*
  Standard site-wide closing CTA band. One consistent message everywhere.
  Only the primary button destination adapts by funnel:
    - default ("audit"): free Business DNA audit
    - "pitch" (Product & Engineering): pitch / scoping flow
*/
export const CtaBand = ({ id = "closing", variant = "audit" }) => {
  const primary =
    variant === "pitch"
      ? { label: "Pitch us your idea", href: "#pitch" }
      : { label: "Get my free audit", to: "/audit" };

  return (
    <section
      id={id}
      className="bg-[var(--dark)] text-[var(--dark-text)]"
      data-testid="cta-band"
    >
      <div className="mx-auto max-w-4xl px-6 py-28 text-center md:px-12 md:py-36">
        <Reveal>
          <h2 className="t-section">See what AI is costing you to ignore.</h2>
        </Reveal>
        <Reveal delay={120}>
          <p className="mx-auto mt-7 max-w-2xl text-base leading-relaxed text-white/70 sm:text-lg">
            Your free Business DNA audit — six scores, real numbers, no pitch. In
            your inbox in days.
          </p>
        </Reveal>
        <Reveal delay={220}>
          <div className="mt-10 flex justify-center">
            <Button
              {...(primary.to ? { to: primary.to } : { href: primary.href })}
              variant="primary"
              data-testid="cta-band-primary"
            >
              {primary.label}
            </Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
